import { render, staticRenderFns } from "./WordsFilter.vue?vue&type=template&id=40e96d04&scoped=true"
import script from "./WordsFilter.vue?vue&type=script&lang=js"
export * from "./WordsFilter.vue?vue&type=script&lang=js"
import style0 from "./WordsFilter.vue?vue&type=style&index=0&id=40e96d04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e96d04",
  null
  
)

export default component.exports